import {
  forwardRef,
  useImperativeHandle,
  useRef,
  type TextareaHTMLAttributes,
} from 'react';

/**
 * 공통 Textarea
 * - resize: none 기본 적용 (style 로 오버라이드 가능)
 * - 스크롤바는 globals.css 의 `textarea::-webkit-scrollbar` + `scrollbar-width: thin` 으로 커스터마이즈
 *   (OverlayScrollbars 는 textarea target 미지원 — v2 기준 — 으로 CSS 방식 채용)
 * - className/ref 모두 native textarea 와 동일한 인터페이스
 *
 * 사용처: 사이트 전역 — 직접 <textarea> 사용 금지 (CLAUDE.md 참고)
 */
export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, style, ...props }, ref) => {
    const innerRef = useRef<HTMLTextAreaElement>(null);
    useImperativeHandle(ref, () => innerRef.current as HTMLTextAreaElement);

    return (
      <textarea
        ref={innerRef}
        {...props}
        style={{ resize: 'none', ...style }}
        className={className}
      />
    );
  },
);
Textarea.displayName = 'Textarea';
